export default __webpack_public_path__ + "static/media/Card1.b5deee5f.jpg";